import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { IonIcon, IonSkeletonText } from "@ionic/react";
import { chevronForward } from "ionicons/icons";
import { useInfiniteGetOrdersHistoryQuery } from "../../../../providers/Orders";
import { useChatsUnreadCount } from "../../../../providers/Chat";
import { useAuth } from "../../../../contexts/auth-context";
import ChatUnreadBadge from "../../../../parhato2/src/entities/ChatUnreadBadge";
import OrderCard from "../../my-orders/order-card";
import cln from "classnames";
import { useConfig } from "../../../../providers/config";

const OrderHistory = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { user } = useAuth();
  const customerId = user ? Number(user.id) || undefined : undefined;
  const config = useConfig();
  const isOrderChatEnabled = !!config.isOrderChatEnabled;
  const unreadChatsCount = useChatsUnreadCount({ customerId, isOrderChatEnabled });

  const { data: lastOrderInfinite, isLoading } = useInfiniteGetOrdersHistoryQuery({
    params: {
      per_page: 1,
      page: 1,
    },
  });

  const lastOrder = lastOrderInfinite?.pages.flat();

  const handleGoToOrderHistory = () => {
    history.push("/my-orders");
  };

  const handleGoToSearch = () => {
    history.push("/home3");
  };

  if (isLoading) {
    return (
      <div className="flex flex-col justify-between gap-4 lg:h-[13rem] ">
        <div className="flex justify-between">
          <IonSkeletonText animated className="h-[1.5rem] w-32 rounded-lg m-0" />
          <IonSkeletonText animated className="h-[1.21875rem] w-20 rounded-lg m-0" />
        </div>
        <IonSkeletonText animated className="h-[7.25rem] lg:h-[11rem] rounded-xl m-0" />
      </div>
    );
  }


  return (
    <>
      {lastOrder?.length === 0 ? (
        <div className="flex flex-col justify-center items-center gap-4 h-[9rem] border-2 border-gray-500 border-dashed p-4 rounded-xl lg:h-[13rem]">
          <div className="text-lg font-bold">{t("You haven't ordered anything yet")}!</div>
          <button className="px-12 py-2 mt-1 rounded-full  bg-primary" onClick={handleGoToSearch}>
            {t("Go to shopping")}
          </button>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <div className="flex justify-between items-center">
            <span className={cln("font-bold text-[1.0625rem]")}>{t("Order history")}</span>
            <div className="flex justify-center items-center gap-1" onClick={handleGoToOrderHistory}>
              <span className="text-xs text-[#868686]">{t("All orders")}</span>
              <IonIcon className="text-xs text-[#868686]" icon={chevronForward} />
              {isOrderChatEnabled && <ChatUnreadBadge count={unreadChatsCount} className="ml-1" />}
            </div>
          </div>
          {lastOrder && <OrderCard order={lastOrder[0]} />}
        </div>
      )}
    </>
  );
};

export default OrderHistory;
